<template>
    <teleport to="body">
        <div v-if="toasts.length" class="toast-host" role="status" aria-live="polite">
            <j-feedback-banner
                v-for="t in toasts"
                :key="t.id"
                :title="t.title"
                :variant="t.variant"
                :on-close="() => dismiss(t.id)"
                class="toast-host__item"
            >
                <template #message>
                    <div>{{ t.message }}</div>
                    <ul v-if="t.errors && t.errors.length" class="toast-host__field-errors">
                        <li v-for="(fe, i) in t.errors" :key="i">
                            <strong>{{ fe.field }}</strong>: {{ fe.message }}
                        </li>
                    </ul>
                    <div v-if="t.code || t.traceId" class="toast-host__meta">
                        <span v-if="t.code">code {{ t.code }}</span>
                        <span v-if="t.code && t.traceId"> · </span>
                        <span v-if="t.traceId">trace {{ t.traceId }}</span>
                    </div>
                </template>
            </j-feedback-banner>
        </div>
    </teleport>
</template>

<script setup>
    // <j-feedback-banner> is globally registered in main.js, so no JS import.
    import toast from '../services/toast.service';

    const toasts = toast.toasts;
    const dismiss = toast.dismiss;
</script>

<style scoped>
    .toast-host {
        position: fixed;
        top: 1.5rem;
        right: 1.5rem;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        max-width: min(28rem, calc(100vw - 3rem));
    }

    .toast-host__item {
        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.18), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    }

    .toast-host__field-errors {
        margin: 0.5rem 0 0;
        padding-left: 1.25rem;
        font-size: 0.875rem;
    }

    .toast-host__meta {
        margin-top: 0.5rem;
        font-size: 0.75rem;
        opacity: 0.7;
        font-variant-numeric: tabular-nums;
    }
</style>
